import { render, staticRenderFns } from "./ApplicationDistribution.vue?vue&type=template&id=877d884c&scoped=true&"
import script from "./ApplicationDistribution.vue?vue&type=script&lang=ts&"
export * from "./ApplicationDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877d884c",
  null
  
)

export default component.exports